
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: ''
  });

  const handleRegister = (e: React.FormEvent) => {
    e.preventDefault();
    // Register logic here
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50" dir="rtl">
      {/* Header */}
      <div className="px-4 pt-12 pb-6">
        <Link to="/login" className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md">
          <i className="ri-arrow-right-line text-xl text-gray-800"></i>
        </Link>
      </div>

      {/* Content */}
      <div className="px-4 pb-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">إنشاء حساب جديد</h1>
          <p className="text-gray-500">انضم إلينا وابدأ التسوق</p>
        </div>

        <form onSubmit={handleRegister} className="space-y-4">
          {/* Name Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">الاسم الكامل</label>
            <div className="relative">
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder="أدخل اسمك الكامل"
                className="w-full px-5 py-3.5 pr-12 rounded-2xl bg-white shadow-md border-none text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
                <i className="ri-user-line text-gray-400 text-lg"></i>
              </div>
            </div>
          </div>

          {/* Email Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">البريد الإلكتروني</label>
            <div className="relative">
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="example@email.com"
                className="w-full px-5 py-3.5 pr-12 rounded-2xl bg-white shadow-md border-none text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
                <i className="ri-mail-line text-gray-400 text-lg"></i>
              </div>
            </div>
          </div>

          {/* Phone Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">رقم الجوال</label>
            <div className="relative">
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                placeholder="05xxxxxxxx"
                className="w-full px-5 py-3.5 pr-12 rounded-2xl bg-white shadow-md border-none text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-gray-400 text-lg"></i>
              </div>
            </div>
          </div>

          {/* Password Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">كلمة المرور</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                placeholder="••••••••"
                className="w-full px-5 py-3.5 pr-12 pl-12 rounded-2xl bg-white shadow-md border-none text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
                <i className="ri-lock-line text-gray-400 text-lg"></i>
              </div>
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center"
              >
                <i className={`${showPassword ? 'ri-eye-line' : 'ri-eye-off-line'} text-gray-400 text-lg`}></i>
              </button>
            </div>
          </div>

          {/* Confirm Password Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">تأكيد كلمة المرور</label>
            <div className="relative">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                value={formData.confirmPassword}
                onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                placeholder="••••••••"
                className="w-full px-5 py-3.5 pr-12 pl-12 rounded-2xl bg-white shadow-md border-none text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 transition-all duration-300"
                required
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center">
                <i className="ri-lock-line text-gray-400 text-lg"></i>
              </div>
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center"
              >
                <i className={`${showConfirmPassword ? 'ri-eye-line' : 'ri-eye-off-line'} text-gray-400 text-lg`}></i>
              </button>
            </div>
          </div>

          {/* Terms */}
          <div className="flex items-start gap-3 pt-2">
            <input
              type="checkbox"
              id="terms"
              className="mt-1 w-5 h-5 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
              required
            />
            <label htmlFor="terms" className="text-sm text-gray-600">
              أوافق على <span className="text-purple-600 font-medium">الشروط والأحكام</span> و <span className="text-purple-600 font-medium">سياسة الخصوصية</span>
            </label>
          </div>

          {/* Register Button */}
          <button
            type="submit"
            className="w-full py-4 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-2xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 mt-6"
          >
            إنشاء الحساب
          </button>

          {/* Login Link */}
          <div className="text-center mt-6">
            <span className="text-gray-600 text-sm">لديك حساب بالفعل؟ </span>
            <Link to="/login" className="text-purple-600 font-bold text-sm">
              سجل دخولك
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
